import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'decision-maker-self-service-responses',
		path: '/admin/decision-makers/self-service-responses',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/admin-decisionMakerSelfServiceResponses" */ './index'),
			{
				exportName: 'AdminDmSelfServiceResponses',
				fallback: Loading,
			},
		),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		// higher than the default priority of the dynamic /admin/decision-makers/:slug details route,
		// so this fixed route isn't shadowed by it
		priority: 10,
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
